import { render, staticRenderFns } from "./PageMaker.vue?vue&type=template&id=31b03999&"
import script from "./PageMaker.vue?vue&type=script&lang=js&"
export * from "./PageMaker.vue?vue&type=script&lang=js&"
import style0 from "@@/core/components/page/PageMaker/PageMakerStylePublic.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports